// src/providers/ToastProvider.tsx
// ═══════════════════════════════════════════════════════════════════════════════
// REACT-TOASTIFY PROVIDER
// ═══════════════════════════════════════════════════════════════════════════════

import React from "react";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ToastProviderProps {
  children: React.ReactNode;
}

/**
 * Toast Provider with React-Toastify
 */
export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        // theme="dark"
        transition={Slide}
        limit={5}
        // toastStyle={{
        //   borderRadius: "8px",
        //   padding: "12px 16px",
        // }}
        toastStyle={{
          // Individual toast styles
          backgroundColor: "rgba(255, 255, 255, 0.1)", // Change this color
          backdropFilter: "blur(10px)",
          borderRadius: "12px",
          padding: "16px",
          color: "#ffffff",
        }}
        // progressStyle={{
        //   // Progress bar styles
        //   background: "linear-gradient(90deg, #4ade80, #60a5fa)",
        //   height: "4px",
        // }}
      />
    </>
  );
};
